import routes from '~/apiRouter';

export const updateUserData = async ({studentData, studentId}) => {
  const body = {
    SNILS: studentData.snils ?? '',
    DIPLOMA_REG_NUMBER: studentData.diplomaRegNumber ?? '',
    DIPLOMA_QUALIFICATION: studentData.diplomaQualification ?? '',
    DIPLOMA_SERIES: studentData.diplomaSeries ?? '',
    DIPLOMA_NUMBER: studentData.diplomaNumber ?? '',
  };

  const options = {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(body),
  };

  const response = await fetch(`${routes.user.edit}${studentId}`, options);

  return response.json();
};